import { Grid, Typography, Button } from '@material-ui/core';
import React, { useState } from 'react';
import KenDialog from '../../../global_components/KenDialogBox';
import KenSelectWrap from '../../../global_components/KenSelect';
import KenInputField from '../../../global_components/KenInputField';
import KenDateTimePicker from '../../../global_components/KenDateTimePicker';
import { KeyboardDateTimePicker } from '@material-ui/pickers';
import { makeStyles, withStyles } from '@material-ui/styles';
import { postAcademicCalendar } from '../../../Utils/apiServices';
import moment from 'moment';
import KenSnackBar from '../../../Components/KenSnackbar';
import { useEffect } from 'react';
import AddBoxIcon from '@material-ui/icons/AddBox';
import IndeterminateCheckBoxIcon from '@material-ui/icons/IndeterminateCheckBox';
// style
const useStyles = makeStyles((theme) => ({
  breadCrumbWrapper: {
    margin: '15px 0',
  },

  header: {
    background: '#ffffff',
    color: theme.palette.KenColors.primary,
  },
  actionBtn: {
    // margin: '0 10 px',
    float: 'right',
  },
  title: {
    fontSize: 18,
    fontWeight: 600,
  },
  popOverTitle: {
    width: '216px',
    minWidth: '200px',
    height: '27px',
    color: '#ffffff',
    backgroundColor: '#092682',
    fontSize: '14px',
    fontWeight: '600',
    padding: '3px 15px',
  },
  holidayButton: {
    textTransform: 'none',
    fontWeight: 'bold',
    marginRight: '5px',
  },
  fitlerButton: {
    textTransform: 'none',
    fontWeight: 'bold',
  },
  sortingSection: {
    display: 'grid',
    gap: '10px',
    gridTemplateColumns: 'repeat(7, 1fr)',
  },
  popOverData: {
    width: '216px',
    minWidth: '200px',
    height: '27px',
    color: '#092682',
    fontSize: '12px',
    fontWeight: '600',
    padding: '3px 15px',
  },
  mainActions: {
    textAlign: 'right',
  },
  popOverHeading: {
    width: '100%',
    fontSize: '14px',
    fontWeight: '400',
    color: '#02195E',
  },
  tableBodyStyle: {
    fontSize: '12px',
    color: '#7A869A',
  },
  tableBodyStyleIgnoreHoliday: {
    fontSize: '12px',
    color: '#7A869A',
    padding: '0px',
  },
  textInputFieldDropDown: {
    background: 'transparent',
    borderRadius: '4px',
    color: '#000',
  },
  textInputField: {
    background: 'transparent',
    borderRadius: '4px',
    color: '#000',
  },
  kenDateTimePickerColor: {
    backgroundColor: '#fff',
  },
  noDataFound: {
    fontWeight: '600',
    fontSize: '14px',
  },
  filterButton: {
    marginRight: '10px',
  },
}));
// Add and Edit Reference Dialogue
const Reference = ({
  title,
  children,
  isOpen,
  handleClose,
  handleEvent,
  positiveBtn,
  negativeBtn,
  selectedTerm,
  handleSelectSubjectChange,
  setConfirmDialogAddReference,
  sessions,
  subjects,
  facultyOptions,
  selectSubjectValue,
  id,
  programName,
  year,
  intake,
  term,
}) => {
  const classes = useStyles();
  // all State
  const [formFields, setFormFields] = useState([]);
  console.log('selectedTerm', selectedTerm);
  const [durationError, setdurationError] = useState([]);

  useEffect(() => {
    if (selectedTerm) {
      setFormFields([
        ...formFields,
        {
          weekNumber: 0,
          typeofActivity: '',
          termId: selectedTerm?.termId,
          startDate: '',
          endDate: '',
          academicCalenderName:
            selectedTerm?.array.length > 0
              ? selectedTerm?.array[0]?.academicCalenderName
              : `${programName} ${year} ${intake} ${term}`,
          numberOfWeeks: '',
        },
      ]);
      setdurationError([{ numberOfWeeks: '', endDate: '' }]);
    }
  }, [intake, programName, selectedTerm, term, year]);

  const [sessionValue, setSessionValue] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [facultyName, setFacultyName] = useState('');
  const [facultyNameTwo, setFacultyNameTwo] = useState('');
  const [facultyNameThree, setFacultyNameThree] = useState('');
  const [activityWeeks, setActivityWeeks] = useState();
  const [weekNumber, setWeekNumber] = useState(0);
  //   SnackBar
  const [openSnackbar, setOpenSnackbar] = React.useState(false);
  const [snackbarSeverity, setSnackbarSeverity] = React.useState('success');
  const [snackbarMessage, setSnackbarMessage] = React.useState('');
  // const [selectSubjectValue, setSelectSubjectValue] = React.useState('');
  console.log('id-------------', id);
  // all methods
  const handleSelectProgramChange = (e, value) => {
    setSessionValue(e.target.value);
  };

  const handleChangedStartDate = (e) => {
    let currentDate = moment(e.target.value);
    if (activityWeeks != undefined) {
      let endDate = currentDate
        .add(activityWeeks, 'weeks')
        .format('YYYY-MM-DD');
      setEndDate(endDate);
    } else {
      handleSnackbarOpen('info', 'Enter number of weeks');
    }
    setStartDate(e.target.value);
    let termStartDate = moment(selectedTerm?.startDate).format('MM/DD/YYYY');
    let weekNo = currentDate.diff(termStartDate, 'week');
    setWeekNumber(weekNo);
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') return;
    setOpenSnackbar(false);
  };

  const handleSnackbarOpen = (severity, message) => {
    setOpenSnackbar(true);
    setSnackbarSeverity(severity);
    setSnackbarMessage(message);
  };
  const handleChangedEndDate = (e) => {
    setEndDate(e.target.value);
  };
  const handleSelectFacultyChange = (e, value) => {
    setFacultyName(e.target.value);
  };

  const handleSelectFacultyTwoChange = (e, value) => {
    setFacultyNameTwo(e.target.value);
  };

  const handleSelectFacultyThreeChange = (e, value) => {
    setFacultyNameThree(e.target.value);
  };
  const handleChangeActivityWeek = (e) => {
    setActivityWeeks(e.target.value);
    if (e.target.value != '') {
      if (startDate != '') {
        let endDate = moment(startDate)
          .add(e.target.value, 'weeks')
          .format('YYYY-MM-DD');
        setEndDate(endDate);
      }
    } else {
      setEndDate('');
    }
  };
  function getWeeksDiffererce(startDate, endDate) {
    const msInWeek = 1000 * 60 * 60 * 24 * 7;

    return Math.round(Math.abs(endDate - startDate) / msInWeek);
  }
  const handleFormChange = (event, index) => {
    let data = [...formFields];
    let dataError = [...durationError];

    if (event.target.name === 'numberOfWeeks') {
      var numbers = /^[0-9]+$/;
      if (event.target.value.match(numbers)) {
        dataError[index]['numberOfWeeks'] = '';
      } else {
        dataError[index]['numberOfWeeks'] = 'please enter vaild numbers';
      }
      console.log('event.target.value', event.target.value);
      if (parseInt(event.target.value) <= parseInt(selectedTerm.termDuration)) {
        dataError[index]['numberOfWeeks'] = '';
      } else {
        dataError[index][
          'numberOfWeeks'
        ] = `Number of weeks cannot be greater than ${selectedTerm.termDuration}`;
      }
      if (data[index]['startDate'] !== '') {
        let endDate = moment(data[index]['startDate'])
          .add(event.target.value, 'weeks')
          .format('YYYY-MM-DD');
        if (endDate > selectedTerm.endDate) {
          dataError[index][
            'endDate'
          ] = `End date cannot be greater than ${selectedTerm.endDate}`;
        } else {
          dataError[index]['endDate'] = '';
        }
        data[index]['endDate'] = endDate;
      }
    }
    if (event.target.name === 'startDate') {
      let currentDate = moment(event.target.value);
      if (data[index].numberOfWeeks !== '') {
        let endDate = currentDate
          .add(data[index].numberOfWeeks, 'weeks')
          .format('YYYY-MM-DD');
        console.log('endDate', endDate);
        if (endDate > selectedTerm.endDate) {
          dataError[index][
            'endDate'
          ] = `End date cannot be greater than ${selectedTerm.endDate}`;
        } else {
          dataError[index]['endDate'] = '';
        }
        data[index]['endDate'] = endDate;
      } else {
        handleSnackbarOpen('info', 'Enter number of weeks');
      }
      data[index]['startDate'] = event.target.value;
      let termStartDate = moment(selectedTerm?.termStartDate).format('MM/DD/YYYY');
      console.log('termStartDate', termStartDate);
      var a = moment(selectedTerm?.termStartDate);
      var b = moment(event.target.value);

      console.log('daysFind', Math.ceil(b.diff(a, 'days') / 7));

      let weekNo = Math.ceil(b.diff(a, 'days') / 7);
      data[index]['weekNumber'] = weekNo;
    }

    data[index][event.target.name] = event.target.value;
    setdurationError(dataError);
    setFormFields(data);
  };
  const handleUpdateEventRefernce = async () => {
    console.log('adddd- edit');
    const objRef = {
      weekNumber: weekNumber,
      typeofActivity: sessionValue,
      termId: selectedTerm.termId,
      startDate: `${startDate}T00:00:00.000Z`,
      endDate: `${endDate}T00:00:00.000Z`,
      academicCalenderName: `${programName} ${year} ${intake} ${term}`,
    };
    await postAcademicCalendar([objRef]);
    setConfirmDialogAddReference(false);
  };

  const addFields = () => {
    let object = {
      weekNumber: 0,
      typeofActivity: '',
      termId: selectedTerm?.termId,
      startDate: '',
      endDate: '',
      academicCalenderName:
        selectedTerm?.array.length > 0
          ? selectedTerm?.array[0]?.academicCalenderName
          : `${programName} ${year} ${intake} ${term}`,
      numberOfWeeks: '',
    };
    setdurationError([...durationError, { numberOfWeeks: '', endDate: '' }]);
    setFormFields([...formFields, object]);
  };

  const removeFields = (index) => {
    let data = [...formFields];
    let dataError = [...durationError];
    data.splice(index, 1);
    dataError.splice(index, 1);
    setFormFields(data);
    setdurationError(dataError);
  };
  const handleAddEventRefernce = async () => {
    const res = await postAcademicCalendar(formFields);
    if (res) {
      handleSnackbarOpen('success', 'Added Successfully');
      setFormFields([
        {
          weekNumber: 0,
          typeofActivity: '',
          termId: selectedTerm?.termId,
          startDate: '',
          endDate: '',
          academicCalenderName:
            selectedTerm?.array.length > 0
              ? selectedTerm?.array[0]?.academicCalenderName
              : `${programName} ${year} ${intake} ${term}`,
          numberOfWeeks: '',
        },
      ]);
      setdurationError([{ numberOfWeeks: '', endDate: '' }]);
      handleClose();
    }
  };

  useEffect(() => {
    if (isOpen) {
      setSessionValue('');
      setActivityWeeks('');
      setEndDate('');
      setStartDate('');
      setFormFields([
        {
          weekNumber: 0,
          typeofActivity: '',
          termId: selectedTerm?.termId,
          startDate: '',
          endDate: '',
          academicCalenderName:
            selectedTerm?.array.length > 0
              ? selectedTerm?.array[0]?.academicCalenderName
              : `${programName} ${year} ${intake} ${term}`,
          numberOfWeeks: '',
        },
      ]);
      setdurationError([{ numberOfWeeks: '', endDate: '' }]);
    }
  }, [isOpen]);
  return (
    <div>
      <KenDialog
        title={
          <Typography variant="h6" className={classes.dialogHeader}>
            {<b>{title}</b>}
          </Typography>
        }
        open={isOpen}
        handleClose={handleClose}
        negativeButtonClick={handleClose}
        positiveButtonClick={
          id ? handleUpdateEventRefernce : handleAddEventRefernce
        }
        positiveButtonText={positiveBtn}
        negativeButtonText={negativeBtn}
        dividers
      >
        <Grid>
          {formFields.map((form, index) => {
            return (
              <div className="add-reference-modal">
                <div className="add-reference-modal-row">
                  <KenSelectWrap
                    label="Type of Activity"
                    options={sessions}
                    onChange={(event) => handleFormChange(event, index)}
                    value={form.typeofActivity}
                    name="typeofActivity"
                    dropdownColor="#FFFFFF"
                    required
                  />
                  <div className="MuiFormControl-root makeStyles-formControl-311">
                    <KenInputField
                      label="No of Weeks"
                      required
                      className="weekNo-input"
                      placeholder="No of Weeks"
                      name="numberOfWeeks"
                      onChange={(event) => handleFormChange(event, index)}
                      value={form.numberOfWeeks}
                      disablePtag={true}
                    />

                    <p style={{ color: 'red', fontSize: '12px' }}>
                      {durationError?.[index]?.numberOfWeeks !== undefined &&
                        durationError?.[index]?.numberOfWeeks}
                    </p>
                  </div>

                  <KenDateTimePicker
                    name={'startDate'}
                    label="Start Date"
                    type="date"
                    minDate={selectedTerm?.termStartDate}
                    maxDate={selectedTerm?.termEndDate}
                    defaultValue={selectedTerm?.startDate}
                    required={true}
                    onChange={(event) => handleFormChange(event, index)}
                    value={form.startDate}
                  />
                  <div className="MuiFormControl-root makeStyles-formControl-311">
                    <KenDateTimePicker
                      name={'endDate'}
                      label="End Date"
                      type="date"
                      required={true}
                      // minDate={selectedTerm?.termStartDate}
                      minDate={form.startDate}

                      maxDate={selectedTerm?.termEndDate}
                      defaultValue={selectedTerm?.startDate}
                      onChange={(event) => handleFormChange(event, index)}
                      value={form.endDate}
                    />

                    <p style={{ color: 'red', fontSize: '12px' }}>
                      {durationError?.[index]?.endDate !== undefined &&
                        durationError?.[index]?.endDate}
                    </p>
                  </div>
                  <div className="icon-main-div">
                    <div className="icon-div">
                      <p class="icon-p-tag">Date</p>
                      {index === formFields.length - 1 && (
                        <span className="plus-div" onClick={addFields}>
                          +
                        </span>
                      )}
                    </div>
                    <div>
                      <p class="icon-p-tag">Date</p>
                      {formFields.length > 1 && (
                        <span
                          className="minus-div"
                          onClick={() => removeFields(index)}
                        >
                          -
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </Grid>
      </KenDialog>
      <KenSnackBar
        message={snackbarMessage}
        severity={snackbarSeverity}
        autoHideDuration={4000}
        open={openSnackbar}
        handleSnackbarClose={handleSnackbarClose}
        position="Bottom-Right"
      />
    </div>
  );
};

export default Reference;
